/**
 * Die Basis für Links, die aus der App HERAUSGEGEBEN werden.
 *
 * ════════════════════════════════════════════════════════════════════════════
 *  WARUM ES DIESE FUNKTION GIBT
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Fünf Stellen bauten ihre Links aus `window.location.origin`. Im Browser ist
 * das richtig. **In der Hülle ist es `capacitor://localhost`** — die Web-Dateien
 * liegen auf dem Gerät und werden nicht von `www.staysuite.app` nachgeladen
 * (siehe `capacitor.config.ts`).
 *
 * Alle fünf Links sind dazu da, weitergegeben zu werden:
 *
 *   - `/e/…`        die öffentliche Anfrageseite — mit „Kopieren"-Knopf daneben
 *   - `/q/…`        der Angebotslink für den Gast (zwei Stellen)
 *   - `/checkin/…`  die Selbstauskunft vor der Anreise
 *   - `/ical/….ics` der Kalender-Feed für Booking.com und Airbnb
 *
 * **Der iCal-Fall ist der teuerste.** Ein Vermieter trägt die Adresse im Portal
 * ein, das Portal kann `capacitor://` nicht auflösen, der Abgleich schlägt
 * still fehl — und er merkt es an einer Doppelbuchung. Kein Fehlerdialog, keine
 * Meldung, nur eine Buchung zu viel.
 *
 * Gefunden am 03.08.2026 bei der Handprüfung H8/H9 zu Vorgang 015, im
 * iOS-Simulator mit angemeldetem Konto. Im Browser ist nichts davon sichtbar.
 *
 * ════════════════════════════════════════════════════════════════════════════
 *  SIE IST IMMER FEST — auch im Browser, auch lokal
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Die erste Fassung nahm im Browser `window.location.origin` und nur in der
 * Hülle die feste Adresse. Begründung: `npm run dev` solle Links erzeugen, die
 * die lokalen Daten zeigen. **Für vier der fünf Links stimmt das. Für den
 * fünften kehrt es sich um, und das ist ausgerechnet der, dessen Ausfall still
 * ist.**
 *
 * `/ical/*` ist eine WEITERLEITUNG in `public/_redirects` auf die Edge Function
 * `ical-feed`. Sie existiert nur auf der Netlify-Site. Vite kennt `_redirects`
 * nicht — also läuft `http://localhost:5180/ical/<token>.ics` in den
 * SPA-Rückfall. Am 03.08.2026 nachgemessen:
 *
 *     localhost:5180/ical/<token>.ics   ->  200  text/html   (index.html!)
 *     www.staysuite.app/ical/<token>.ics ->  404  text/plain  (die Function)
 *
 * Ein Portal, das die erste Antwort abruft, bekommt **Erfolg und HTML**. Es
 * meldet nichts. Genau daraus wird die Doppelbuchung, wegen der dieser Befund
 * überhaupt aufgeschrieben wurde — der lokale Link ist nicht „weniger nützlich"
 * als der echte, er ist schlechter als gar keiner.
 *
 * Zwei weitere Fälle zeigen in dieselbe Richtung, beide betreffen den Browser:
 *
 *   • Der Netlify-DRAFT ist team-geschützt (`CLAUDE.md`). Ein Gastlink von dort
 *     landet auf einer Netlify-Anmeldeseite.
 *   • `staysuite.app` ohne `www` antwortet mit 301. Für einen Menschen egal,
 *     für einen Portal-Abrufer nicht zwingend.
 *
 * Deshalb keine Verzweigung. Eine Fallunterscheidung, die überall dasselbe
 * liefern MUSS, sähe aus wie eine Entscheidung und wäre keine.
 *
 * **Was das kostet, offen gesagt:** Wer lokal einen Angebotslink prüfen will,
 * bekommt einen Link auf die Produktion. Das ist der bewusste Preis — ein Link,
 * den man beim Entwickeln von Hand umschreiben muss, gegen einen Link, der beim
 * Vermieter still nichts tut.
 *
 * Die Adresse steht hier als Literal, und das ist erlaubt: Die Sperre in diesem
 * Projekt gilt PREISEN (`src/data/pakete.test.ts`), nicht Adressen. Sie ist
 * dieselbe wie die Vorgabe von `APP_BASE_URL` in `send-guest-mail` und
 * `APP_URL` in `invoice-pay`.
 */
const OEFFENTLICH = 'https://www.staysuite.app'

export function oeffentlicheBasis(): string {
  return OEFFENTLICH
}

/**
 * Ein Pfad an der öffentlichen Basis. `pfad` beginnt mit einem Schrägstrich.
 *
 * Es gibt sie, damit die Aufrufer nicht jedes Mal selbst zusammensetzen — und
 * damit ein doppelter Schrägstrich nicht fünfmal einzeln verhindert werden
 * muss.
 */
export function oeffentlicheUrl(pfad: string): string {
  return oeffentlicheBasis().replace(/\/+$/, '') + (pfad.startsWith('/') ? pfad : `/${pfad}`)
}
